export const GET_TODO_lOADING = "GET_TODO_lOADING";
export const GET_TODO_SUCCESS = "GET_TODO_SUCCESS";
export const GET_TODO_ERROR = "GET_TODO_ERROR";


export const getTodoLoading = () => ({
    type: GET_TODO_lOADING

});

export const getTodoSuccess = (payload) => ({
    type: GET_TODO_SUCCESS,
    payload
});

export const getTodoError = () => ({
    type: GET_TODO_ERROR
});


//GET_TODOS_SUCCESS --> res --> how will you use this response in redux store;